module.exports = __webpack_public_path__ + "static/media/howToObtainCoordinates.c48daf7d.mp4";